{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2017 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSWEBJSONReader;

//{$DEFINE RTLONLY}
{$IFNDEF RTLONLY}
{$I WEBLib.TMSWEBDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$ELSE}
//RTL ONLY
{$IFDEF IOS}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$IFDEF ANDROID}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}

{$SCOPEDENUMS ON}
{$INLINE ON}{$R-}{$Q-}

interface

uses
  {$IFNDEF LCLWEBLIB}
  Generics.Collections,
  {$ENDIF}
  Classes, SysUtils, WEBLib.TMSWEBTypes;

type
  TTMSWEBJSONStreamReader = class
  public
    type
      EInvalidJsonInput = class(Exception)
      public
        constructor Create;
      end;
      EInternalError = class(Exception)
      public
        constructor Create;
      end;
      EEndOfInputReached = class(Exception)
      public
        constructor Create;
      end;
  private
  var
    FStream: TStream;
    FReadStream: TStringStream;
  public
    constructor Create(const aStream: TStream);
    destructor Destroy; override;
    function NextChar: char; inline;
    function PeekChar: char; inline;
    function ReadChar: char; inline;
    procedure Backup(const {%H-}c: char);
    procedure MoveNext(const Count: integer = 1); inline;
    function Eof: boolean; inline;
  end;

  TTMSWEBJSONToken = (jstoBeginObject, jstoEndObject, jstoBeginArray, jstoEndArray,
    jstoName, jstoBoolean, jstoNull, jstoText, jstoNumber, jstoEOF);

  TTMSWEBJSONReader = class
  private
    type
      TTMSWEBJSONState = (jstNone, jstBeginObject, jstEndObject, jstBeginArray, jstEndArray, jstTrue, jstFalse,
        jstNull, jstDoubleQuoted, jstBuffered, jstDoubleQuotedName, jstInt64, jstNumber, jstEOF);
      TTMSWEBJSONNumberState = (jnstNone, jnstSign, jnstDigit, jnstDecimal, jnstFraction, jnstExpE, jnstExpSign, jnstExpDigit);
      TTMSWEBJSONScope = (jscEmptyDocument, jscEmptyArray, jscEmptyObject, jscNonEmptyDocument,
        jscNonEmptyArray, jscNonEmptyObject, jscDanglingName);
  public
    type
      EInvalidStateException = class(Exception)
      public
        constructor Create(const AState: TTMSWEBJSONState);
      end;
      EUnterminatedArray = class(Exception)
      public
        constructor Create;
      end;
      EUnterminatedObject = class(Exception)
      public
        constructor Create;
      end;
      ENameExpected = class(Exception)
      public
        constructor Create;
      end;
      EColonExpected = class(Exception)
      public
        constructor Create;
      end;
      EReaderClosed = class(Exception)
      public
        constructor Create;
      end;
      EMultipleRootNotAllowed = class(Exception)
      public
        constructor Create;
      end;
      EExpectedValue = class(Exception)
      public
        constructor Create;
      end;
      EObjectOrArrayExpected = class(Exception)
      public
        constructor Create;
      end;
      ETooManyDepthLevels = class(Exception)
      public
        constructor Create;
      end;
      EInvalidEscaped = class(Exception)
      public
        constructor Create;
      end;
    const
      MaxNumberBuffer = 255;
      MaxStackSize = 255;
  private
    FReader: TTMSWEBJSONStreamReader;
    FStack: array[0..MaxStackSize] of TTMSWEBJSONScope;
    FStackSize: integer;
    FPeeked: TTMSWEBJSONState;
    FPeekedInt64: Int64;
    FPeekedNumber: array[0..MaxNumberBuffer] of Char;
    FPeekedString: string;
    function NextPeek: TTMSWEBJSONState; inline;
    procedure CheckState(const State: TTMSWEBJSONState); inline;
    procedure SkipChar;
    function IsLiteral(C: Char): boolean;
    function IsDigit(C: Char): boolean; inline;
    function DoPeek: TTMSWEBJSONState;
    procedure PushScope(const Scope: TTMSWEBJSONScope);
    function NextNonWhitespace: Char;
    function ReadChar: Char;
    function PeekKeyword: TTMSWEBJSONState;
    function PeekNumber: TTMSWEBJSONState;
    function InternalReadQuoted(const BuildString: boolean): string;
    function ReadQuoted: string;
    procedure SkipQuoted;
  private
    function SkipWhitespaceUntilEnd: boolean;
  public
    constructor Create(const AStream: TStream);
    destructor Destroy; override;
    procedure ReadBeginArray;
    procedure ReadEndArray;
    procedure ReadBeginObject;
    procedure ReadEndObject;
    function PeekName: string;
    function ReadName: string;
    function ReadString: string;
    function ReadBoolean: boolean;
    function ReadDouble: double;
    function ReadInt64: Int64;
    function ReadInteger: integer;
    procedure SkipValue;
    procedure ReadNull;
    function HasNext: boolean;
    function HasInt64: Boolean;
    function HasDouble: Boolean;
    function HasBoolean: Boolean;
    function HasString: Boolean;
    function Peek: TTMSWEBJSONToken;
    function IsNull: boolean;
    function Eof: boolean;
  end;

implementation

uses
  WEBLib.TMSWEBUtils;

const
  Wspace: Set of byte = [$20, $A, $D, $9, $C];

{$IFNDEF LCLWEBLIB}
const
  FPC_FULLVERSION = 0;
{$ENDIF}

function ArrayOfCharToString(AArray: array of char): string;
{$IFDEF WEBLIB}
var
  I: Integer;
{$ENDIF}
begin
  {$IFDEF WEBLIB}
  Result := '';
  for I := 0 to Length(AArray) - 1 do
  begin
    if AArray[I] = #0 then
      Break;

    Result := Result + AArray[I];
  end;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  Result := string(AArray);
  {$ENDIF}
end;

{ TTMSWEBJSONReader }

constructor TTMSWEBJSONReader.Create(const aStream: TStream);
begin
  inherited Create;
  FReader := TTMSWEBJSONStreamReader.Create(aStream);
  FPeeked := TTMSWEBJSONState.jstNone;
  FStack[0] := TTMSWEBJSONScope.jscEmptyDocument;
  FStackSize := 1;
end;

destructor TTMSWEBJSONReader.Destroy;
begin
  FReader.Free;
  inherited;
end;

function TTMSWEBJSONReader.Eof: boolean;
begin
  Result := (Peek = TTMSWEBJSONToken.jstoEOF);
end;

function TTMSWEBJSONReader.Peek: TTMSWEBJSONToken;
begin
  case NextPeek of
    TTMSWEBJSONState.jstBeginObject:
      Result := TTMSWEBJSONToken.jstoBeginObject;

    TTMSWEBJSONState.jstEndObject:
      Result := TTMSWEBJSONToken.jstoEndObject;

    TTMSWEBJSONState.jstBeginArray:
      Result := TTMSWEBJSONToken.jstoBeginArray;

    TTMSWEBJSONState.jstEndArray:
      Result := TTMSWEBJSONToken.jstoEndArray;

    TTMSWEBJSONState.jstDoubleQuotedName:
      Result := TTMSWEBJSONToken.jstoName;

    TTMSWEBJSONState.jstTrue,
    TTMSWEBJSONState.jstFalse:
      Result := TTMSWEBJSONToken.jstoBoolean;

    TTMSWEBJSONState.jstNull:
      Result := TTMSWEBJSONToken.jstoNull;

    TTMSWEBJSONState.jstDoubleQuoted,
    TTMSWEBJSONState.jstBuffered:
      Result := TTMSWEBJSONToken.jstoText;

    TTMSWEBJSONState.jstInt64,
    TTMSWEBJSONState.jstNumber:
      Result := TTMSWEBJSONToken.jstoNumber;

    TTMSWEBJSONState.jstEOF:
      Result := TTMSWEBJSONToken.jstoEOF;
  else
    Assert(false);
    Result := TTMSWEBJSONToken.jstoEOF;
  end;
end;

function TTMSWEBJSONReader.PeekKeyword: TTMSWEBJSONState;
begin
  case FReader.PeekChar of
    't', 'T':
      begin
        FReader.MoveNext;
        case FReader.NextChar of
          'r', 'R': case FReader.NextChar of
            'u', 'U': case FReader.NextChar of
              'e', 'E':
                if FReader.EOF or not IsLiteral(FReader.PeekChar) then
                  Exit(TTMSWEBJSONState.jstTrue);
            end;
          end;
        end;
      end;
    'f', 'F':
      begin
        FReader.MoveNext;
        case FReader.NextChar of
          'a', 'A': case FReader.NextChar of
            'l', 'L': case FReader.NextChar of
              's', 'S': case FReader.NextChar of
                'e', 'E':
                  if FReader.EOF or not IsLiteral(FReader.PeekChar) then
                    Exit(TTMSWEBJSONState.jstFalse);
              end;
            end;
          end;
        end;
      end;
    'n', 'N':
      begin
        FReader.MoveNext;
        case FReader.NextChar of
          'a', 'A': case FReader.NextChar of
            'n', 'N':
              if FReader.EOF or not IsLiteral(FReader.PeekChar) then
                Exit(TTMSWEBJSONState.jstNull);
          end;

          'u', 'U': case FReader.NextChar of
            'l', 'L': case FReader.NextChar of
              'l', 'L':
                if FReader.EOF or not IsLiteral(FReader.PeekChar) then
                  Exit(TTMSWEBJSONState.jstNull);
            end;
          end;
        end;
      end;
  else
    Exit(TTMSWEBJSONState.jstNone);
  end;
  raise EExpectedValue.Create;
end;

function TTMSWEBJSONReader.PeekName: string;
var
  p: Int64;
begin
  p := FReader.FReadStream.Position;
  Result := ReadQuoted;
  FReader.FReadStream.Position := p;
end;

function TTMSWEBJSONReader.PeekNumber: TTMSWEBJSONState;
const
  MinIncompleteInteger = Low(Int64) div 10;
var
  Last: TTMSWEBJSONNumberState;
  Negative: boolean;
  FitsInInt64: boolean;
  Value: Int64;
  NewValue: Int64;
  C: Char;
  BufIndex: integer;
begin
  C := FReader.PeekChar;
  if (C <> '-') and not IsDigit(C) then
    Exit(TTMSWEBJSONState.jstNone);

  Negative := false;
  FitsInInt64 := true;
  Last := TTMSWEBJSONNumberState.jnstNone;
  BufIndex := 0;
  Value := -1;
  repeat
    if BufIndex >= MaxNumberBuffer then
      raise EExpectedValue.Create;
    C := FReader.NextChar;
    FPeekedNumber[BufIndex] := C;
    Inc(BufIndex);
    case C of
      '-':
        if Last = TTMSWEBJSONNumberState.jnstNone then
        begin
          Negative := true;
          Last := TTMSWEBJSONNumberState.jnstSign;
          Continue;
        end
        else
        if Last = TTMSWEBJSONNumberState.jnstExpE then
        begin
          Last := TTMSWEBJSONNumberState.jnstExpSign;
          Continue;
        end
        else
          raise EExpectedValue.Create;
      '+':
        if Last = TTMSWEBJSONNumberState.jnstExpE then
        begin
          Last := TTMSWEBJSONNumberState.jnstExpSign;
          Continue;
        end
        else
          raise EExpectedValue.Create;
      'e', 'E':
        if Last in [TTMSWEBJSONNumberState.jnstDigit, TTMSWEBJSONNumberState.jnstFraction] then
        begin
          Last := TTMSWEBJSONNumberState.jnstExpE;
          Continue;
        end
        else
          raise EExpectedValue.Create;
      '.':
        if Last = TTMSWEBJSONNumberState.jnstDigit then
        begin
          Last := TTMSWEBJSONNumberState.jnstDecimal;
          Continue;
        end
        else
          raise EExpectedValue.Create;
    else
      if not IsDigit(C) then
        if not IsLiteral(C) then
        begin
          FReader.Backup(C);
          Dec(BufIndex);
          Break;
        end
        else
          raise EExpectedValue.Create;

      if Last in [TTMSWEBJSONNumberState.jnstSign, TTMSWEBJSONNumberState.jnstNone] then
      begin
        Value := -(Ord(C) - 48);
        Last := TTMSWEBJSONNumberState.jnstDigit
      end
      else
      if Last = TTMSWEBJSONNumberState.jnstDigit then
      begin
        if Value = 0 then
          raise EExpectedValue.Create;
        NewValue := Value * 10 - (Ord(C) - 48);
        FitsInInt64 := FitsInInt64 and (
            (Value > MinIncompleteInteger)
             or ((Value = MinIncompleteInteger) and (NewValue < Value))
          );
        Value := NewValue;
      end
      else
      if Last = TTMSWEBJSONNumberState.jnstDecimal then
        Last := TTMSWEBJSONNumberState.jnstFraction
      else
      if Last in [TTMSWEBJSONNumberState.jnstExpE, TTMSWEBJSONNumberState.jnstExpSign] then
        Last := TTMSWEBJSONNumberState.jnstExpDigit;
    end;
  until false;

  if (Last = TTMSWEBJSONNumberState.jnstDigit) and FitsInInt64 and ((Value <> Low(Int64)) or Negative) then
  begin
    if Negative then
      FPeekedInt64 := Value
    else
      FPeekedInt64 := -Value;
    Exit(TTMSWEBJSONState.jstInt64);
  end
  else
  if Last in [TTMSWEBJSONNumberState.jnstDigit, TTMSWEBJSONNumberState.jnstFraction, TTMSWEBJSONNumberState.jnstExpDigit] then
  begin
    FPeekedNumber[BufIndex] := #0;
    Exit(TTMSWEBJSONState.jstNumber);
  end
  else
    raise EExpectedValue.Create;
end;

procedure TTMSWEBJSONReader.PushScope(const Scope: TTMSWEBJSONScope);
begin
  if FStackSize > MaxStackSize then
    raise ETooManyDepthLevels.Create;
  FStack[FStackSize] := Scope;
  Inc(FStackSize);
end;

function TTMSWEBJSONReader.HasBoolean: Boolean;
begin
  Result := (Peek in [TTMSWEBJSONToken.jstoBoolean]);
end;

function TTMSWEBJSONReader.HasDouble: Boolean;
begin
  Result := (NextPeek in [TTMSWEBJSONState.jstNumber]);
end;

function TTMSWEBJSONReader.HasInt64: Boolean;
begin
  Result := (NextPeek in [TTMSWEBJSONState.jstInt64]);
end;

function TTMSWEBJSONReader.HasNext: boolean;
begin
  Result := not (NextPeek in [TTMSWEBJSONState.jstEndObject, TTMSWEBJSONState.jstEndArray]);
end;

function TTMSWEBJSONReader.HasString: Boolean;
begin
  Result := (Peek in [TTMSWEBJSONToken.jstoText]);
end;

function TTMSWEBJSONReader.IsDigit(C: Char): boolean;
begin
  Result := (C <= #255) and CharIsNumber(C);
end;

function TTMSWEBJSONReader.IsLiteral(C: Char): boolean;
begin
  Result := not TTMSWEBUtils.CharInSet(C, TTMSWEBUtils.CreateCharSet('/\;#{}[]:,'' '#13#10#12#9));
end;

function TTMSWEBJSONReader.IsNull: boolean;
begin
  Result := (Peek = TTMSWEBJSONToken.jstoNull);
end;

function TTMSWEBJSONReader.NextNonWhitespace: Char;
var
  s: Char;
  p: Int64;
begin
  p := FReader.FReadStream.Position;
  Result := #0;
  s := ReadChar;
  repeat
    if (s > #32) or not (Ord(s) in Wspace) then
    begin
      FReader.FReadStream.Position := p;
      Exit(s);
    end;

    s := ReadChar;
  until FReader.Eof;
  FReader.FReadStream.Position := p;
end;

function TTMSWEBJSONReader.NextPeek: TTMSWEBJSONState;
begin
  if FPeeked = TTMSWEBJSONState.jstNone then
    FPeeked := DoPeek;
  Result := FPeeked;
end;

procedure TTMSWEBJSONReader.SkipQuoted;
begin
  InternalReadQuoted(false);
end;

procedure TTMSWEBJSONReader.SkipValue;
var
  Count: integer;
begin
  Count := 0;
  repeat
    case NextPeek of
      TTMSWEBJSONState.jstBeginArray:
        begin
          PushScope(TTMSWEBJSONScope.jscEmptyArray);
          Inc(Count);
        end;
      TTMSWEBJSONState.jstBeginObject:
        begin
          PushScope(TTMSWEBJSONScope.jscEmptyObject);
          Inc(Count);
        end;
      TTMSWEBJSONState.jstEndArray, TTMSWEBJSONState.jstEndObject:
        begin
          Dec(FStackSize);
          Dec(Count);
        end;
      TTMSWEBJSONState.jstDoubleQuoted, TTMSWEBJSONState.jstDoubleQuotedName:
        SkipQuoted;
    end;
    FPeeked := TTMSWEBJSONState.jstNone;
  until Count <= 0;
end;

procedure TTMSWEBJSONReader.SkipChar;
begin
  FReader.MoveNext;
  while Ord(FReader.PeekChar) in Wspace do
    FReader.MoveNext;
end;

function TTMSWEBJSONReader.DoPeek: TTMSWEBJSONState;
var
  FPeekStack: TTMSWEBJSONScope;
  C: Char;
begin
  FPeekStack := FStack[FStackSize - 1];
  if FPeekStack = TTMSWEBJSONScope.jscEmptyArray then
    FStack[FStackSize - 1] := TTMSWEBJSONScope.jscNonEmptyArray
  else
  if FPeekStack = TTMSWEBJSONScope.jscNonEmptyArray then
  begin
    C := NextNonWhitespace;
    case C of
      ']':
        begin
          while Ord(FReader.PeekChar) in Wspace do
            FReader.MoveNext;

          SkipChar;
          FPeeked := TTMSWEBJSONState.jstEndArray;
          Exit(FPeeked);
        end;
      ',':
         SkipChar;
    else
      raise EUnterminatedArray.Create;
    end;
  end
  else
  if FPeekStack in [TTMSWEBJSONScope.jscEmptyObject, TTMSWEBJSONScope.jscNonEmptyObject] then
  begin
    FStack[FStackSize - 1] := TTMSWEBJSONScope.jscDanglingName;
    if FPeekStack = TTMSWEBJSONScope.jscNonEmptyObject then
    begin
      C := NextNonWhitespace;
      case C of
        '}':
          begin
            while Ord(FReader.PeekChar) in Wspace do
              FReader.MoveNext;

            SkipChar;
            FPeeked := TTMSWEBJSONState.jstEndObject;
            Exit(FPeeked);
          end;
        ',': SkipChar;
      else
        raise EUnterminatedObject.Create;
      end;
    end;
    C := NextNonWhitespace;
    case C of
      '"':
        begin
          SkipChar;
          FPeeked := TTMSWEBJSONState.jstDoubleQuotedName;
          Exit(FPeeked);
        end;
      '}':
        if FPeekStack <> TTMSWEBJSONScope.jscNonEmptyObject then
        begin
          SkipChar;
          FPeeked := TTMSWEBJSONState.jstEndObject;
          Exit(FPeeked);
        end else
          raise ENameExpected.Create;
    else
      raise ENameExpected.Create;
    end;
  end
  else
  if FPeekStack = TTMSWEBJSONScope.jscDanglingName then
  begin
    FStack[FStackSize - 1] := TTMSWEBJSONScope.jscNonEmptyObject;
    C := NextNonWhitespace;
    if C = ':' then
      SkipChar
    else
      raise EColonExpected.Create;
  end
  else
  if FPeekStack = TTMSWEBJSONScope.jscEmptyDocument then
    FStack[FStackSize - 1] := TTMSWEBJSONScope.jscNonEmptyDocument
  else
  if FPeekStack = TTMSWEBJSONScope.jscNonEmptyDocument then
  begin
    if SkipWhitespaceUntilEnd then
    begin
      FPeeked := TTMSWEBJSONState.jstEOF;
      Exit(FPeeked);
    end else
      raise EMultipleRootNotAllowed.Create;
  end;

  C := NextNonWhitespace;
  case C of
    ']':
      if FPeekStack = TTMSWEBJSONScope.jscEmptyArray then
      begin
        SkipChar;
        FPeeked := TTMSWEBJSONState.jstEndArray;
        Exit(FPeeked);
      end else
        raise EExpectedValue.Create;
    '"':
      begin
        if FStackSize = 1 then
          raise EObjectOrArrayExpected.Create;
        SkipChar;
        FPeeked := TTMSWEBJSONState.jstDoubleQuoted;
        Exit(FPeeked);
      end;
    '[':
      begin
        SkipChar;
        FPeeked := TTMSWEBJSONState.jstBeginArray;
        Exit(FPeeked);
      end;
    '{':
      begin
        SkipChar;
        FPeeked := TTMSWEBJSONState.jstBeginObject;
        Exit(FPeeked);
      end;
  end;

  if FStackSize = 1 then
    raise EObjectOrArrayExpected.Create;

  Result := PeekKeyword;
  if Result <> TTMSWEBJSONState.jstNone then
    Exit;
  Result := PeekNumber;
  if Result <> TTMSWEBJSONState.jstNone then
    Exit;
  raise EExpectedValue.Create;
end;

function TTMSWEBJSONReader.SkipWhitespaceUntilEnd: boolean;
var
  s: Char;
  p: Int64;
begin
  p := FReader.FReadStream.Position;
  Result := True;
  s := ReadChar;
  repeat
    if (s > #32) or not (Ord(s) in Wspace) then
    begin
      FReader.FReadStream.Position := p;
      Exit(false);
    end;

    s := ReadChar;
  until FReader.Eof;
  FReader.FReadStream.Position := p;
end;

procedure TTMSWEBJSONReader.CheckState(const State: TTMSWEBJSONState);
begin
  if NextPeek <> State then
    raise EInvalidStateException.Create(State);
end;

procedure TTMSWEBJSONReader.ReadBeginArray;
begin
  CheckState(TTMSWEBJSONState.jstBeginArray);
  PushScope(TTMSWEBJSONScope.jscEmptyArray);
  FPeeked := TTMSWEBJSONState.jstNone;
end;

procedure TTMSWEBJSONReader.ReadEndArray;
begin
  CheckState(TTMSWEBJSONState.jstEndArray);
  Dec(FStackSize);
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadBoolean: boolean;
begin
  case NextPeek of
    TTMSWEBJSONState.jstTrue:
      Result := True;
    TTMSWEBJSONState.jstFalse:
      Result := False;
  else
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstTrue);
  end;
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadChar: Char;
begin
  Result := FReader.ReadChar;
end;

function TTMSWEBJSONReader.ReadDouble: double;
begin
  case NextPeek of
    TTMSWEBJSONState.jstInt64:
      begin
        FPeeked := TTMSWEBJSONState.jstNone;
        Exit(FPeekedInt64);
      end;
    TTMSWEBJSONState.jstNumber:
      begin
        if TTMSWEBUtils.TryStrToFloatDot(ArrayOfCharToString(FPeekedNumber), Result) then
        begin
          FPeeked := TTMSWEBJSONState.jstNone;
          Exit;
        end else
          FPeekedString := ArrayOfCharToString(FPeekedNumber);
      end;
    TTMSWEBJSONState.jstDoubleQuoted:
      FPeekedString := ReadQuoted;
    TTMSWEBJSONState.jstBuffered: ;
  else
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstNumber);
  end;

  FPeeked := TTMSWEBJSONState.jstBuffered;
  Result := TTMSWEBUtils.StrToFloatDot(FPeekedString);
  FPeekedString := '';
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadInt64: Int64;
var
  AsDouble: double;
begin
  case NextPeek of
    TTMSWEBJSONState.jstInt64:
      begin
        FPeeked := TTMSWEBJSONState.jstNone;
        Exit(FPeekedInt64);
      end;
    TTMSWEBJSONState.jstNumber:
      begin
        if TryStrToInt64(ArrayOfCharToString(FPeekedNumber), Result) then
        begin
          FPeeked := TTMSWEBJSONState.jstNone;
          Exit;
        end else
          FPeekedString := ArrayOfCharToString(FPeekedNumber);
      end;
    TTMSWEBJSONState.jstDoubleQuoted:
      begin
        FPeekedString := ReadQuoted;
        if TryStrToInt64(FPeekedString, Result) then
        begin
          FPeeked := TTMSWEBJSONState.jstNone;
          Exit;
        end;
      end;
    TTMSWEBJSONState.jstBuffered: ;
  else
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstInt64);
  end;

  FPeeked := TTMSWEBJSONState.jstBuffered;
  AsDouble := TTMSWEBUtils.StrToFloatDot(FPeekedString);
  Result := Round(AsDouble);
  if AsDouble <> Result then
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstInt64);
  FPeekedString := '';
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadInteger: integer;
var
  AsDouble: double;
begin
  case NextPeek of
    TTMSWEBJSONState.jstInt64:
      begin
        Result := Integer(FPeekedInt64);
        if Result <> FPeekedInt64 then
          raise EInvalidStateException.Create(TTMSWEBJSONState.jstInt64);
        FPeeked := TTMSWEBJSONState.jstNone;
        Exit;
      end;
    TTMSWEBJSONState.jstNumber:
      begin
        if TryStrToInt(ArrayOfCharToString(FPeekedNumber), Result) then
        begin
          FPeeked := TTMSWEBJSONState.jstNone;
          Exit;
        end else
          FPeekedString := ArrayOfCharToString(FPeekedNumber);
      end;
    TTMSWEBJSONState.jstDoubleQuoted:
      begin
        FPeekedString := ReadQuoted;
        if TryStrToInt(FPeekedString, Result) then
        begin
          FPeeked := TTMSWEBJSONState.jstNone;
          Exit;
        end;
      end;
    TTMSWEBJSONState.jstBuffered: ;
  else
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstInt64); // todo
  end;

  FPeeked := TTMSWEBJSONState.jstBuffered;
  AsDouble := TTMSWEBUtils.StrToFloatDot(FPeekedString);
  Result := Round(AsDouble);
  if AsDouble <> Result then
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstInt64);
  FPeekedString := '';
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadName: string;
begin
  CheckState(TTMSWEBJSONState.jstDoubleQuotedName);
  FPeeked := TTMSWEBJSONState.jstNone;
  Result := ReadQuoted;
end;

procedure TTMSWEBJSONReader.ReadNull;
begin
  CheckState(TTMSWEBJSONState.jstNull);
  FPeeked := TTMSWEBJSONState.jstNone;
end;

procedure TTMSWEBJSONReader.ReadBeginObject;
begin
  CheckState(TTMSWEBJSONState.jstBeginObject);
  PushScope(TTMSWEBJSONScope.jscEmptyObject);
  FPeeked := TTMSWEBJSONState.jstNone;
end;

procedure TTMSWEBJSONReader.ReadEndObject;
begin
  CheckState(TTMSWEBJSONState.jstEndObject);
  Dec(FStackSize);
  FPeeked := TTMSWEBJSONState.jstNone;
end;

function TTMSWEBJSONReader.ReadQuoted: string;
begin
  Result := InternalReadQuoted(true);
end;

function TTMSWEBJSONReader.InternalReadQuoted(const BuildString: boolean): string;
var
  pc, c: String;
  s: string;
begin
  Result := '';
  s := '';
  pc := '';
  while not FReader.Eof do
  begin
    c := ReadChar;
    if (c = '"') and (pc <> '\') then
      Break
    else
      s := s + c;

    pc := c;
  end;

  if BuildString then
    Result := s;
end;

function TTMSWEBJSONReader.ReadString: string;
begin
  case NextPeek of
    TTMSWEBJSONState.jstDoubleQuoted:
      Result := ReadQuoted;
    TTMSWEBJSONState.jstInt64:
      Result := IntToStr(FPeekedInt64);
    TTMSWEBJSONState.jstNumber:
      Result := ArrayOfCharToString(FPeekedNumber);
    TTMSWEBJSONState.jstBuffered:
      Result := FPeekedString;
  else
    raise EInvalidStateException.Create(TTMSWEBJSONState.jstDoubleQuoted);
  end;
  FPeeked := TTMSWEBJSONState.jstNone;

  Result := TTMSWEBUtils.UnescapeString(Result);
end;

{ TTMSWEBJSONStreamReader }

constructor TTMSWEBJSONStreamReader.Create(const aStream: TStream);
begin
  FStream := aStream;
  FReadStream := TStringStream.Create(''{$IFDEF WEBLIB}, TEncoding.Ansi{$ENDIF});
  FReadStream.CopyFrom(FStream, FStream.Size);
  FReadStream.Position := 0;
end;

destructor TTMSWEBJSONStreamReader.Destroy;
begin
  FReadStream.Free;
  inherited;
end;

function TTMSWEBJSONStreamReader.NextChar: char;
begin
  if (Eof) then
    raise EEndOfInputReached.Create;
  Result := ReadChar;
end;

function TTMSWEBJSONStreamReader.PeekChar: char;
var
  p: Int64;
begin
  p := FReadStream.Position;
  Result := ReadChar;
  FReadStream.Position := p;
end;

function TTMSWEBJSONStreamReader.ReadChar: char;
var
  i: Integer;
  s: string;
begin
  Result := #0;
  {$IFDEF ZEROSTRINGINDEX}
  i := 0;
  {$ELSE}
  i := 1;
  {$ENDIF}
  if FReadStream.Position < FReadStream.Size then
  begin
    s := FReadStream.ReadString(1);
    {$IFNDEF WEBLIB}
    {$HINTS OFF}
    {$WARNINGS OFF}
    {$IFDEF LCLLIB}
    {$IF FPC_FULLVERSION = 30200}
    //BUG IN TStringStream in FPC 3.2
    FReadStream.Position := FReadStream.Position + 1;
    {$IFEND}
    {$ENDIF}
    {$HINTS ON}
    {$WARNINGS ON}
    {$ENDIF}
    if (s <> '') {$IFDEF WEBLIB} and Assigned(s) {$ENDIF} then
      Result := s[i]
  end;
end;

procedure TTMSWEBJSONStreamReader.Backup(const c: char);
begin
  FReadStream.Position := FReadStream.Position - 1;
end;

procedure TTMSWEBJSONStreamReader.MoveNext(const Count: integer = 1);
begin
  FReadStream.Position := FReadStream.Position + Count;
end;

function TTMSWEBJSONStreamReader.Eof: boolean;
begin
  Result := FReadStream.Position = FReadStream.Size;
end;

{ TTMSWEBJSONReader.EInvalidStateException }

constructor TTMSWEBJSONReader.EInvalidStateException.Create(const AState: TTMSWEBJSONState);
begin
  inherited CreateFmt('Invalid Json parser state. Expected state: %d', [Ord(AState)]);
end;

{ TTMSWEBJSONReader.EUnterminatedArray }

constructor TTMSWEBJSONReader.EUnterminatedArray.Create;
begin
  inherited Create('Unterminated array');
end;

{ TTMSWEBJSONReader.EUnterminatedObject }

constructor TTMSWEBJSONReader.EUnterminatedObject.Create;
begin
  inherited Create('Unterminated object');
end;

{ TTMSWEBJSONReader.ENameExpected }

constructor TTMSWEBJSONReader.ENameExpected.Create;
begin
  inherited Create('Name expected');
end;

{ TTMSWEBJSONReader.EColonExpected }

constructor TTMSWEBJSONReader.EColonExpected.Create;
begin
  inherited Create('Colon expected');
end;

{ TTMSWEBJSONReader.EReaderClosed }

constructor TTMSWEBJSONReader.EReaderClosed.Create;
begin
  inherited Create('Reader already closed');
end;

{ TTMSWEBJSONReader.EMultipleRootNotAllowed }

constructor TTMSWEBJSONReader.EMultipleRootNotAllowed.Create;
begin
  inherited Create('Multiple root values not allowed');
end;

{ TTMSWEBJSONReader.EExpectedValue }

constructor TTMSWEBJSONReader.EExpectedValue.Create;
begin
  inherited Create('Value expected but invalid character found');
end;

{ TTMSWEBJSONReader.EObjectOrArrayExpected }

constructor TTMSWEBJSONReader.EObjectOrArrayExpected.Create;
begin
  inherited Create('Object or array expected as top-level value');
end;

{ TTMSWEBJSONReader.ETooManyDepthLevels }

constructor TTMSWEBJSONReader.ETooManyDepthLevels.Create;
begin
  inherited Create('Maximum level of nested structured reached.');
end;

{ TTMSWEBJSONStreamReader.EInvalidJsonInput }

constructor TTMSWEBJSONStreamReader.EInvalidJsonInput.Create;
begin
  inherited Create('Invalid JSON Input');
end;

{ TTMSWEBJSONStreamReader.EInternalError }

constructor TTMSWEBJSONStreamReader.EInternalError.Create;
begin
  inherited Create('JSON stream reader internal error');
end;

{ TTMSWEBJSONStreamReader.EEndOfInputReached }

constructor TTMSWEBJSONStreamReader.EEndOfInputReached.Create;
begin
  inherited Create('End of JSON input reached.');
end;

{ TTMSWEBJSONReader.EInvalidEscaped }

constructor TTMSWEBJSONReader.EInvalidEscaped.Create;
begin
  inherited Create('Invalid escaped sequence');
end;

end.
